import api from '@/api';

const resource = 'ei/distribuirconceito';

export default {
  getDistribuirConceito(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
  postDistribuirConceito(data) {
    return api.post(`${resource}`, data);
  },
  deleteDistribuirConceito(data) {
    return api.delete(`${resource}`, {
      params: data,
    });
  },
};
